export default "__VITE_ASSET__DQXT_UqC__"